import api from ".";
import { IQuestion } from "../types/question";
import cookiesModifier from "../utils/cookies";

export const updateQuestion = async (data: any) => {
    const url = `questions/${data.id}`;


    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.patch(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const createQuestion = async (data: any) => {
    const url = `questions`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const reorderQuestion = async (payload: { id: number, action: string }) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`questions/reorder/${payload.id}/${payload.action}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteQuestion = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`questions/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const getQuestionsByCriteriaGroup = async (criteriaGroupId: number) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`questions/criteria-groups/${criteriaGroupId}`);

        return res.data as IQuestion[];
    } catch (error) {
        throw error;
    }
}

export const getQuestionsByQuestionnaireCode = async (questCode: string) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`questions/questionnaire/${questCode}`);

        return res.data as IQuestion[];
    } catch (error) {
        throw error;
    }
}